import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import Select from 'react-select';

export default function LendingApplications() {
    const params = useParams();
    const [lists, setLists] = useState([]);
    const [clients, setClients] = useState([]);
    const [allData, setAllData] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchText, setSearchText] = useState("");
    const [status, setStatus] = useState("");
    const [lenderApplicationId, setLenderApplicationId] = useState("00000000-0000-0000-0000-000000000000");
    const [clientId, setClientId] = useState("00000000-0000-0000-0000-000000000000");
    const [businessLegalName, setBusinessLegalName] = useState("");

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    };

    const resetForm = () => {
        const resetStatus = "";
        const resetClientId = "00000000-0000-0000-0000-000000000000";

        setSearchText("");
        setLenderApplicationId("00000000-0000-0000-0000-000000000000");
        setBusinessLegalName("");
        setClientId(resetClientId);
        setStatus(resetStatus);
        setLists([]);
        setAllData([]); // Clear search results

        GetData(1, resetStatus, resetClientId);
    };

    const clearresetForm = () => {
        setErrors({});
        GetData(pageNumber);
        setBusinessLegalName("");
    };

    const GetLastPageData = () => {
        GetData(totalPages);
    };

    const GetFirstPageData = () => {
        GetData("1");
    };

    const GetPageData = (number) => {
        setPageNumber(number);
        if (pageNumber !== number) GetData(number);
    };

    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map((number) => {
        return (
            <li className="page-item" key={number} id={number} onClick={() => GetPageData(number)}>
                <Link className="page-link">{number}</Link>
            </li>
        );
    });

    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETELENDINGAPPLICATION + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData(pageNumber);
                    } else {
                        handleError(response.data.message);
                        GetData(pageNumber);
                    }
                });
        }
    };

    const GetData = (number, passedStatus = status, passedClientId = clientId) => {
        axios.get(
            config.APIACTIVATEURL + config.GETLENDINGAPPLICATIONS +
            "?status=" + passedStatus + 
            "&ClientId=" + passedClientId + 
            "&pageNumber=" + number + 
            "&pageSize=" + pageSize,
            { ...headerconfig }
        ).then((response) => {
            if (response.status === 200) {
                setLists(response.data.data.data);
                setPageNumber(response.data.data.pageNumber);
                setPageSize(response.data.data.pageSize);
                setTotalPages(response.data.data.totalPages);
                setData(response.data.data);
                setTotalRecords(response.data.data.totalRecords);
            }
        });
    };
    
    
    const handleSearchInput = (e) => {
        const { value } = e.target;
        setBusinessLegalName(value);

        if (value.length > 2) {
            axios.get(config.APIACTIVATEURL + config.ADMINSEARCHLENDINGAPPLICATION + "?keyword=" + value, { ...headerconfig })
                .then((response) => {
                    setAllData(response.data.data);
                });
        } else {
            setAllData([]); 
        }
    };

    
    const handleSearchButton = () => {
        if (lenderApplicationId !== "00000000-0000-0000-0000-000000000000") {
            GetListById(lenderApplicationId);
        } else if (businessLegalName.length > 2) {
            axios.get(config.APIACTIVATEURL + config.ADMINSEARCHLENDINGAPPLICATION + "?keyword=" + businessLegalName, { ...headerconfig })
                .then((response) => {
                    setAllData(response.data.data);
                });
        } else {
            GetData(pageNumber);
            setAllData([]);
        }
    };

    const GetListById = (lendingApplicationId) => {
        axios
            .get(config.APIACTIVATEURL + config.GETLENDINGAPPLICATION + "/" + lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLists([response.data.data]);
                } else {
                    setLists([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching lending application:", error);
                setLists([]);
            });
    };

    const handleSelect = (lendingApplication) => {
        GetListById(lendingApplication.lendingApplicationId);
        setSearchText(lendingApplication.businessLegalName + " - " + lendingApplication.oFirstName);
        setBusinessLegalName(lendingApplication.businessLegalName + " - " + lendingApplication.oFirstName); // Update the input field
        setLenderApplicationId(lendingApplication.lendingApplicationId);
        setAllData([]);
    };

    const GetClients = () => {
        axios.get(config.APIACTIVATEURL + config.GETALLCLIENTS, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setClients(response.data.data);
                }
            });
    };

    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";

    useEffect(() => {
        GetData(pageNumber);
        GetClients();
        if (params.status != undefined) {
            setStatus(params.status);
        } else {
            setStatus("");
        }
    }, []);

    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="card card-body py-3">
                        <div className="row g-4 align-items-center">
                            <div className="col-sm-5">
                                <div className="search-box">
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        className="form-control search"
                                        placeholder="Search for Company..."
                                        name="businessLegalName"
                                        onChange={handleSearchInput}
                                        value={businessLegalName}
                                    />
                                    <i className="ri-search-line search-icon" />
                                    <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px" }}>
                                        {allData.length > 0 && allData.map(m =>
                                            <li
                                                className="locationListVideoItem"
                                                onClick={() => handleSelect(m)}
                                                key={m.lendingApplicationId}
                                            >
                                                {m.businessLegalName} - {m.oFirstName}
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <Select
                                    options={[
                                        { value: "00000000-0000-0000-0000-000000000000", label: "All Clients" },
                                        ...clients.map(c => ({ value: c.clientId, label: c.clientName }))
                                    ]}
                                    onChange={(selectedOption) => setClientId(selectedOption.value)}
                                    value={{
                                        value: clientId,
                                        label: clientId === "00000000-0000-0000-0000-000000000000"
                                            ? "All Clients"
                                            : clients.find(c => c.clientId === clientId)?.clientName || "Select Client"
                                    }}
                                    styles={{
                                        menu: (provided) => ({
                                            ...provided,
                                            maxHeight: '300px',
                                            overflowY: 'auto',
                                        }),
                                    }}
                                    isSearchable={true}
                                    placeholder="Select Client"
                                />
                            </div>
                            <div className="col-sm-2">
                                <select
                                    className="form-select"
                                    onChange={(e) => setStatus(e.target.value)}
                                    value={status}
                                >
                                    <option value="">All Status</option>
                                    <option value="SUBMITTED">Submitted</option>
                                    <option value="PENDING">Pending</option>
                                    <option value="APPLIED">Pending Approval</option>
                                    <option value="APPROVED">Approved</option>
                                    <option value="REJECTED">Rejected</option>
                                    <option value="WAITINGFORFUNDS">Awaiting Funding</option>
                                    <option value="FUNDED">Funded</option>
                                </select>
                            </div>
                            <div className="col-sm-auto ms-auto">
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={handleSearchButton}
                                    >
                                        Search
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={resetForm}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card w-100 position-relative">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="px-4 py-3 border-bottom">
                                    <h4 className="mb-2 card-title">Client Applications</h4>
                                </div>
                                <div className="card-body p-3">
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Client</th>
                                                    <th>Company</th>
                                                    <th>Owner Name</th>
                                                    <th>Email</th>
                                                    <th>Mobile</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {lists.length > 0 && lists.map((v, index) =>
                                                    <tr key={v.lenderId}>
                                                        <td>{index + 1}</td>
                                                        <td>{v.clientName || v.oFirstName}</td>
                                                        <td>{v.businessLegalName}</td>
                                                        <td>{v.ownerName || v.oFirstName + " " + v.oLastName}</td>
                                                        <td>{v.businessEmail}</td>
                                                        <td>{v.businessPhoneNumber}</td>
                                                        <td>
                                                            {v.status === "SUBMITTED" ? (
                                                                <span className="badge text-bg-primary">SUBMITTED</span>
                                                            ) : v.status === "APPLIED" ? (
                                                                <span className="badge text-bg-warning">PENDING APPROVAL</span>
                                                            ) : v.status === "APPROVED" ? (
                                                                <span className="badge text-bg-success">APPROVED</span>
                                                            ) : v.status === "REJECTED" ? (
                                                                <span className="badge text-bg-danger">REJECTED</span>
                                                            ) : (
                                                                <span className="badge text-bg-secondary">{v.status}</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                                                                    <Link className="edit-item-btn" to={"/lendingapplication/" + v.lendingApplicationId}><i className="ri-pencil-fill align-bottom text-muted" /></Link>
                                                                </li>
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                                    <Link className="edit-item-btn" to={"/viewlendingapplication/" + v.lendingApplicationId}><i className="ri-eye-fill align-bottom text-muted" /></Link>
                                                                </li>
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                                                    <Link className="remove-item-btn" onClick={e => onDelete(e, v.lendingApplicationId)}>
                                                                        <i className="ri-delete-bin-fill align-bottom text-danger" />
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                        <div className="flex-shrink-0">
                                            <div className="text-muted">
                                                Showing <span className="fw-semibold">{lists.length}</span> of <span className="fw-semibold">{totalRecords}</span> Results
                                            </div>
                                        </div>
                                        <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li className={"page-item" + (data.previousPage === null ? 'disabled' : '')} onClick={() => GetFirstPageData()}>
                                                <Link className="page-link">Previous</Link>
                                            </li>
                                            {renderPageNumbers}
                                            <li className={"page-item" + (data.nextPage === null ? 'disabled' : '')} onClick={() => GetLastPageData()}>
                                                <Link className="page-link">Next</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}